export default {
  selectedItem(state) {
    return state.selectedItem;
  },
};
